<template><section><!-- ---
title: 二叉树遍历
date: 2022-10-31
tags: 算法
--- -->
<p>二叉树有多种遍历方法，本文对二叉树的先序、中序、后序的非递归遍历进行分析。代码编写为 javascript。</p>
<h3>1. 前序遍历</h3>
<p>遍历顺序为：根左右</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">tranveral</span>(<span class="hljs-params">root, res = []</span>) </span>{
    <span class="hljs-keyword">if</span> (!root) <span class="hljs-keyword">return</span> res
    res.push(root.val)
    tranveral(root.left, res)
    tranveral(root.right, res)
    <span class="hljs-keyword">return</span> res
}
</code></pre>
<h3>2. 后序遍历</h3>
<p>遍历顺序为：左根右</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> inorderTraversal = <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">root, res=[]</span>) </span>{
    <span class="hljs-keyword">if</span> (!root) <span class="hljs-keyword">return</span> res
    inorderTraversal(root.left, res)
    res.push(root.val)
    inorderTraversal(root.right, res)
    <span class="hljs-keyword">return</span> res
};
</code></pre>
<h3>3. 中序遍历</h3>
<p>遍历顺序为：左右根</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> postorderTraversal = <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">root, res = []</span>) </span>{
    <span class="hljs-keyword">if</span> (!root) <span class="hljs-keyword">return</span> res
    postorderTraversal(root.left, res)
    postorderTraversal(root.right, res)
    res.push(root.val)
    <span class="hljs-keyword">return</span> res
};
</code></pre>
</section></template>

